import React from 'react';
import { Box, Flex, FlexProps, BoxProps, Text, TextProps } from 'pounceV2';
import { stringToPaleColor } from 'Helpers/colors';

interface BulletedValueProps extends FlexProps {
  value: string;
  color?: BoxProps['backgroundColor'];
  textVariant?: TextProps['variant'];
  emphasized?: boolean;
}

const BulletedValueV3: React.FC<BulletedValueProps> = ({
  value,
  color,
  emphasized = false,
  textVariant = 'body/sm',
  ...rest
}) => {
  return (
    <Flex gap={1.5} align="center" {...rest}>
      <Box
        as="div"
        width={8}
        height={8}
        backgroundColor={color || (stringToPaleColor(value) as any)}
        borderRadius="circle"
      />
      <Text variant={textVariant} fontWeight={emphasized ? 'semibold' : 'medium'}>
        {value}
      </Text>
    </Flex>
  );
};

export default BulletedValueV3;
